window.ModalWindow = (function() {
    function ModalWindow(settings) {
        this.settings = {
            // Содержимое (текст, html)
            content: settings.content || '',
            // Заголовок
            title: settings.title || '',
            // Подпись рядом с заголовком
            subtitle: settings.subtitle || '',
            // Нужна ли обертка для содержимого (header с кнопкой закрытия, body с установленными стилями)
            hasWrapper: settings.hasWrapper === false ? false : true,
            // Закрывать окно по клику на фон (затенение)
            closeByBackground: settings.closeByBackground === false ? false : true,
            // Закрывать окно по клику на клавишу Esc
            closeByEscape: settings.closeByEscape === false ? false : true,
            // Дополнительный css-класс, присваеваемый родительскому элементу модального окна (overlay)
            className: settings.className || '',
            // Нужно ли выравнивать окно по центру экрана
            shouldBeCentrified: settings.shouldBeCentrified === false ? false : true,

            // При закрытии окна не удаляет его из DOM
            hideWithoutRemoving: settings.hideWithoutRemoving === true ? true : false,

            // Можно ли менять размер окна и перетаскивать его
            resizable: settings.resizable === true ? true : false,

            // дополнительный css-класс для body
            bodyClassname: settings.bodyClassname || '',

            // Событие, срабатывающее перед открытием окна
            beforeShow: settings.beforeShow || function() {},
            // Событие, срабатывающее перед закрытием окна
            beforeHide: settings.beforeHide || function() {},
            // Событие, срабатывающее после открытия окна
            afterShow: settings.afterShow || function() {},
            // Событие, срабатывающее после закрытия окна
            afterHide: settings.afterHide || function () { },

            containerWidth: settings.containerWidth,
            containerHeight: settings.containerHeight
        };

        return this;
    };

    ModalWindow.prototype.generateDOM = function() {
        var body = $('body'),
            html = $(generateHTML(this.settings)),
            content = this.settings.content;

        this.dom = {
            overlay: html,
            container: html.find('[js-node="modal-container"]'),
            title: html.find('[js-node="modal-title"]'),
            subtitle: html.find('[js-node="modal-subtitle"]'),
            closeBtn: html.find('[js-node="modal-close"]'),
            body: html.find('[js-node="modal-body"]'),
        };

        if(this.settings.hasWrapper === false)
            this.dom.container.html(content);

        body.append(html);
    };

    ModalWindow.prototype.bindUIActions = function() {
        var self = this;

        if(self.settings.closeByBackground) {
            this.dom.overlay.on('click', function (e) {
                if ($(e.target).attr('js-node') === 'modal-overlay')
                    self.hide();
            });
        }

        this.dom.closeBtn.on('click', function(e) {
            self.hide();
        });

        if(self.settings.closeByEscape) {
            $(document).on('keyup.hideModalWindow', function (e) {
                if (e.keyCode === 27) {
                    self.hide();
                }
            });
        }
    };

    ModalWindow.prototype.unbindUIActions = function() {
        this.dom.overlay.off('click');
        this.dom.closeBtn.off('click');
        $(document).off('keyup.hideModalWindow');
    };

        /**
            var data = {
                content: '',
                title: '',
                    subtitle: ''
            }
        **/
    ModalWindow.prototype.updateContent = function (data) {
        if(data.hasOwnProperty('content')) {
            if (this.settings.hasWrapper)
                this.dom.body.html(data.content);
            else
                this.dom.container.html(data.content);
        }

        if(data.hasOwnProperty('title')) {
            if (this.dom.title) {
                this.dom.title.html(data.title);
            }
        }

        if(data.hasOwnProperty('subtitle')) {
            if (this.dom.subtitle) {
                this.dom.subtitle.html(data.subtitle);
            }
        }

        this.updateDimension();
    };

    ModalWindow.prototype.updateDimension = function () {
        if (this.settings.shouldBeCentrified) {
            this.dom.container.css({
                'margin-left': -this.dom.container.width() / 2,
                'margin-top': -this.dom.container.height() / 2,
            });
        }
    };

    ModalWindow.prototype.moveTo = function (x, y) {
        this.dom.container.css({
            left: x,
            top: y
        });
    };

    ModalWindow.prototype.show = function (animationDuration) {
        var self = this;

        animationDuration = animationDuration || 200;

        if (this.hasOwnProperty('dom') === false) {
            this.generateDOM();
            this.bindUIActions();
        }

        this.settings.beforeShow();

        this.dom.overlay.fadeIn(animationDuration, function () {
            self.settings.afterShow();
        });
        //this.dom.container.addClass('opened');
        this.updateDimension();
    };

    ModalWindow.prototype.hide = function (animationDuration) {
        var self = this;

        animationDuration = animationDuration || 200;

        if (!this.dom) return;

        this.settings.beforeHide();

        this.dom.overlay.fadeOut(animationDuration, function () {
            self.settings.afterHide();

            if (self.settings.hideWithoutRemoving === false) {
                self.unbindUIActions();
                self.dom.overlay.remove();

                delete self.dom;
                delete self.settings;
            }
        });

        //this.dom.container.removeClass('opened');
    };

    ModalWindow.prototype.destroy = function() {
        this.unbindUIActions();
        this.dom.overlay.remove();
    };

    ModalWindow.prototype.loadingEnable = function () {
        this.dom.container.find('[js-node="modal__loader-overlay"]').addClass('visible');
    };

    ModalWindow.prototype.loadingDisable = function () {
        this.dom.container.find('[js-node="modal__loader-overlay"]').removeClass('visible');
    };

    function generateHTML(settings) {
        var className = settings.className !== '' ? ' ' + settings.className : '';
        var style = '';
        if (settings.containerWidth)
            style += 'width: ' + settings.containerWidth + 'px;';
        if (settings.containerHeight)
            style += 'height: ' + settings.containerHeight + 'px;';

        return [
            '<div class="modal__overlay' + className + '" js-node="modal-overlay">',
                '<div class="modal__container" js-node="modal-container" style="' + style + '">',
                    settings.hasWrapper === true ? generateWrapper(settings) : '',
                '</div>',
            '</div>'
        ].join('\n');
    };

    function generateWrapper(settings) {
        return [
            '<div class="modal__header">',
                '<div class="modal__title">',
                    '<span class="modal__title-text" js-node="modal-title">' + settings.title + '</span>',
                    settings.subtitle.length > 0 ? '<span class="modal__subtitle" js-node="modal-subtitle">' + settings.subtitle + '</span>' : '',
                '</div>',
                '<div class="modal__close-button" js-node="modal-close">',
                    Utils.svgHtml('close', 'modal__close-icon'),
                '</div>',
            '</div>',
            '<div class="modal__body ' + settings.bodyClassname + '" js-node="modal-body">',
                settings.content,
            '</div>',
                        '<div class="modal__loader" js-node="modal__loader-overlay">',
                '<div class="modal__loader-spiner-wrapper">',
                    '<div class="modal__loader-spiner-container">',
                        '<div class="modal__loader-spiner-speeding-wheel"></div>',
                    '</div>',
                '</div>',
                '<div class="modal__loader-text">'+ window.Localization.getString('Scripts_Shared_Modules.ModalWindow_29', 'Идёт отправка') + '</div>',
            '</div>',
        ].join('\n');
    };

    return ModalWindow;
}());